var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubesvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M15.7373 2.07958C15.561 1.46858 15.0414 0.987384 14.3817 0.824082C13.186 0.527344 8.39117 0.527344 8.39117 0.527344C8.39117 0.527344 3.59639 0.527344 2.40062 0.824082C1.74092 0.98741 1.22135 1.46858 1.04501 2.07958C0.724609 3.18704 0.724609 5.49765 0.724609 5.49765C0.724609 5.49765 0.724609 7.80827 1.04501 8.91573C1.22135 9.52672 1.74092 9.98787 2.40062 10.1512C3.59639 10.4479 8.39117 10.4479 8.39117 10.4479C8.39117 10.4479 13.1859 10.4479 14.3817 10.1512C15.0414 9.98787 15.561 9.52672 15.7373 8.91573C16.0577 7.80827 16.0577 5.49765 16.0577 5.49765C16.0577 5.49765 16.0577 3.18704 15.7373 2.07958ZM6.823 7.59552V3.39979L10.8305 5.4977L6.823 7.59552Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubesvg);
export default __webpack_public_path__ + "static/media/youtubesvg.148ca30daa23af4bb8404eb5029ca4f0.svg";
export { ForwardRef as ReactComponent };